import { render, staticRenderFns } from "./ProdCategory.vue?vue&type=template&id=2eb30a71&scoped=true&"
import script from "./ProdCategory.vue?vue&type=script&lang=js&"
export * from "./ProdCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProdCategory.vue?vue&type=style&index=0&id=2eb30a71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb30a71",
  null
  
)

export default component.exports